module.exports = __webpack_public_path__ + "static/media/tree-alt.d4c17a10.svg";